module.exports = __webpack_public_path__ + "img/bg3.4c8d19ba.jpg";